export default "__VITE_ASSET__DhsbuhEN__"